<template>
  <div class="member-list">
    <div class="loading" v-if="country === null"></div> 
    <div class="container"  v-if="country !== null">  
    
      <h1 class="headline" v-if="country !== null"><img :src="flagsPath + country.img"/> {{country.name}}</h1>
      <p class="center" v-if="country.memberCount > 0">{{country.memberCount}} total members</p >
      
      <div v-if="representatives.president.length > 0">
        <h1>{{$t('message.president')}}</h1>
        <div class="prestige-box" v-for="item in representatives.president" :key="item.map" @click="goMember(item)">  
          <div class="avatar prestige-box-avatar">  
            <img class="" :src="item.memberImage" @error="onImageError"/>
          </div>
          <div class="prestige-box-text-area">  
            <h1>{{item.firstname}} {{item.lastname}}</h1>
            <p>MAP {{item.map}}</p>
            <p>{{item.dojo}} {{item.img}}</p>
            <!--p>{{item.birthday | moment('Do MMMM YYYY')}}</p-->
            <img :src="beltsPath + item.belt_img"/>
          </div>
        </div>
      </div>
      
      <div v-if="representatives.nationalCoaches.length > 0">
        <h2>{{$t('message.nationalCoaches')}}</h2>
        <div class="details-box">  
          <div class="list-outer">  
            <div class="list-item" v-for="item in representatives.nationalCoaches" :key="item.map" @click="goMember(item)">  
              <div class="list-item-image"><img :src="item.memberImage" @error="onImageError"/></div>
              <div class="list-item-caption">
                <div class="list-item-title">{{item.firstname}} {{item.lastname}}</div>
                <div class="list-item-subtitle">MAP {{item.map}}</div>
              </div>
              <div class="list-item-additionals">
                <div class="list-item-additional"><img :src="beltsPath + item.belt_img"/></div>          
                <div class="list-item-additional"><img :src="dojoLogoPath + item.dojo_id + '.jpg'" @error="onImageError"/></div>            
              </div>         
            </div> 
          </div> 
        </div> 
      </div>
      
      <div v-if="representatives.officials.length > 0">
        <h2>{{$t('message.officials')}}</h2>
        <div class="details-box">  
          <div class="list-outer">  
            <div class="list-item" v-for="item in representatives.officials" :key="item.map" @click="goMember(item)">  
              <div class="list-item-image"><img :src="item.memberImage" @error="onImageError"/></div>
              <div class="list-item-caption">
                <div class="list-item-title">{{item.firstname}} {{item.lastname}}</div>
                <div class="list-item-subtitle">MAP {{item.map}}</div>
              </div>
              <div class="list-item-additionals">
                <div class="list-item-additional"><img :src="beltsPath + item.belt_img"/></div>          
                <div class="list-item-additional"><img :src="dojoLogoPath + item.dojo_id + '.jpg'" @error="onLogoImageError"/></div>            
              </div>         
            </div> 
          </div> 
        </div> 
      </div>
      
      <div v-if="dojos"> 
        <h2>Dojos</h2>
        <p class="light">{{dojos.length}} GCO dojos in {{country.name}}</p>
        <div class="simple-list-outer" v-if="dojos != null">        
          <div class="simple-list-item" v-for="item in dojos" :key="item.id" @click="goDojo(item)">  
            <div class="simple-list-item-image"><img :src="dojoLogoPath + item.id + '.jpg'" @error="onLogoImageError"/></div>
            <div class="simple-list-item-title">{{item.dojo}}</div>
            <div class="simple-list-item-additional">{{item.memberCount}}</div>              
          </div>        
        </div>
      </div>

      <div v-if="country.memberCount <= 300">
        <h2>{{$t('message.members')}}</h2>
        <div class="details-list">  
            <div class="list-item" v-for="item in members" @click="goMember(item)" :key="item.map">  
              <div class="list-item-image">  
                <img :src="item.memberImage" @error="onImageError"/>
              </div>
              <div class="list-item-caption">
                <div class="list-item-title">{{item.firstname}} {{item.lastname}}</div>
                <div class="list-item-subtitle">MAP {{item.map}}</div>
              </div>
              <div class="list-item-additionals">
                <div class="list-item-additional"><img :src="beltsPath + item.belt_img"/></div>                    
              </div> 
            </div>
          </div>        
        </div>      
      </div>
    </div>
  </div>
</template>

<script>
// import _ from 'lodash'
import { mapGetters } from 'vuex'

export default {
  name: 'Country',
  data () {
    return {
      countryId: 0
    }
  },
  methods: {
    getCountry: function () {
      this.$store.dispatch('countries/getDetails', this.countryId).then(() => {
        this.getRepresentatives()
        this.getDojos()
        this.getMembers()
      })
    },
    getRepresentatives: function () {
      this.$store.dispatch('countries/getRepresentatives', this.countryId)
    },
    getDojos: function () {
      this.$store.dispatch('countries/getDojos', this.countryId)
    },
    getMembers: function () {
      this.$store.dispatch('countries/getMembers', this.countryId)
    },
    goDojo: function (item) {
      var breadcrumb = {
        name: item.dojo,
        route: '/dojo/' + item.id
      }
      this.$store.commit('ADD_BREADCRUMB', breadcrumb)
      this.$router.push(breadcrumb.route)
    },
    onLogoImageError: function (event) {
      event.target.src = './dojo-dummy.png'
    },
    onImageError: function (event) {
      event.target.src = './person-dummy.png'
    },
    goMember: function (item) {
      var breadcrumb = {
        name: item.firstname + ' ' + item.lastname,
        route: '/member/' + item.map
      }
      this.$store.commit('ADD_BREADCRUMB', breadcrumb)
      // window.location.href = './#/member/' + item.map
      this.$router.push(breadcrumb.route)
    }
  },
  computed: {
    ...mapGetters({
      country: 'countries/details',
      dojos: 'countries/dojos',
      members: 'countries/members',
      representatives: 'countries/representatives',
      dojoLogoPath: 'dojos/logoPath',
      flagsPath: 'countries/flagsPath',
      beltsPath: 'members/beltsPath'
    })
  },
  activated: function () {
    this.countryId = this.$route.params.id
    this.getCountry()
  }
}
</script>
